import { VISIBLE } from 'src/constants/appConstants';

// Utility for setting the procedure dropdown
export function setProcedureDropdownUtil({
    value,
    flag = false,
    setDownArrow,
    reportUsageObject,
    setProcedureDropdownValue,
    resetProcedurePage,
    procedureTypeUsageVisibility,
    salesOrg,
    setDraft,
    dispatch,
    setProcedureValue,
    getProcedureInfoRequest,
    setTemporaryProcedureDropdownValue,
    procedureDropdownValue,
    isDraft,
    usageDetails
}) {
    setDownArrow(false);
     if(value === undefined){
         setProcedureDropdownValue(value);
         return;
       }
        if (
            value?.procedureCode && value?.procedureCode !== reportUsageObject?.procedureCode &&
            !flag
        ) {
            setProcedureDropdownValue(value);
            resetProcedurePage();

            const data = {
                procedureCode:
                    procedureTypeUsageVisibility === VISIBLE &&
                        value?.procedureCode
                        ? value?.procedureCode
                        : procedureTypeUsageVisibility === VISIBLE &&
                            reportUsageObject?.procedureCode
                            ? reportUsageObject?.procedureCode
                            : '',
                salesOrg: salesOrg,
            };
            setDraft(false);
            dispatch(
                setProcedureValue({
                    procedureCode: procedureDropdownValue?.procedureCode,
                    procedureDescription:
                        procedureDropdownValue?.procedureDescription,
                })
            );
            Object.keys(value).length > 0 &&
                dispatch(getProcedureInfoRequest('Usage', data));
        } else if(value?.procedureCode){
          !( usageDetails?.procedureCode?.length>0 && !isDraft) && setDownArrow(true);
            setTemporaryProcedureDropdownValue(value);
        }
    }